import {NgModule} from '@angular/core'
import {ServiceOverviewPageComponent} from './service-overview-page.component'
import {ServiceOverviewPageRoutingModule} from './service-overview-page-routing.module'
import {TranslocoModule} from '@ngneat/transloco'
import {CommonModule} from '@angular/common'
import {SupportSectionComponent} from '../../../shared/components/content/support-section/support-section.component'
import {PartnersComponent} from '../../../craft/partners/partners.component'
import {ServicesSectionComponent} from '../../../shared/components/content/services-section/services-section.component'

@NgModule({
  declarations: [ServiceOverviewPageComponent],
  imports: [
    ServiceOverviewPageRoutingModule,
    TranslocoModule,
    ServicesSectionComponent,
    PartnersComponent,
    CommonModule,
    SupportSectionComponent,
  ],
})
export class ServiceOverviewPageModule {}
